<template>
    <div>
        <div v-if="!error">
            <div v-if="data.totalItems > 0">
                <div class="row">
                    <div class="col-md-4">
                        <div class="widget-thumb widget-bg-color-white text-uppercase text-center margin-bottom-20 bordered">
                            <h4 class="widget-thumb-heading" v-text="$lang.get('trans.documents_to_generate')"></h4>
                            <div class="widget-thumb-wrap">
                                <div class="widget-thumb-body">
                                    <span class="widget-thumb-body-stat" data-counter="counterup" :data-value="data.totalItems">{{ data.totalItems }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="widget-thumb widget-bg-color-white text-uppercase text-center margin-bottom-20 bordered">
                            <h4 class="widget-thumb-heading" v-text="$lang.get('trans.time_to_process')"></h4>
                            <div class="widget-thumb-wrap">
                                <div class="widget-thumb-body">
                                    <span class="widget-thumb-body-stat" data-counter="counterup" data-value="7,644">
                                        <span v-if="calculatingTimeToProcess">--:--:--</span>
                                        <span v-else v-text="timeNeededToProcessRequest"></span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="widget-thumb widget-bg-color-white text-uppercase text-center margin-bottom-20 bordered">
                            <h4 class="widget-thumb-heading" v-text="$lang.get('trans.start_the_process')"></h4>
                            <div class="widget-thumb-wrap">
                                <div class="widget-thumb-body">
                                    <button class="btn btn-lg btn-outline dark" @click="generate" v-if="!generating">
                                        <i class="glyphicon glyphicon-cogs"></i> {{ $lang.get('trans.generate_documents') }}
                                    </button>
                                    <div style="margin-left: 50%; transform: translateX(-50%)" v-if="generating">
                                        <radial-progress-bar :diameter="120"
                                                             :completed-steps="secondsPassedSinceProcessingRequest"
                                                             :total-steps="secondsNeededToProcessRequest"
                                                             innerStrokeColor="#a5a5a5"
                                                             startColor="#000000"
                                                             stopColor="#000000"
                                                             strokeWidth="15"
                                        >
                                        </radial-progress-bar>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-12">
                        <info-state :text="$lang.get('trans.generate_step_info_text')"></info-state>
                    </div>
                </div>
            </div>
            <div v-else>
                <error-state :text="$lang.get('trans.error_missing_items')"></error-state>
            </div>
        </div>

        <error-state v-else :text="error"></error-state>

    </div>
</template>

<script>
    import moment from 'moment'
    import RadialProgressBar from 'vue-radial-progress'
    import ErrorState from 'components/global/ErrorState'
    import InfoState from 'components/global/InfoState'

    export default {
        name: "generate-documents",

        components: {
            RadialProgressBar,
            ErrorState,
            InfoState,
        },

        props: {
          'data' : {
            type: Object
          },
          showFinishButton: {
            type: String
          },
        },

        data() {
            return {
                calculatingTimeToProcess: true,
                secondsNeededToProcessRequest: 0,
                secondsPassedSinceProcessingRequest: 0,
                downloadUrl: null,
                generating: false,
                error: null
            }
        },

        computed: {
            timeNeededToProcessRequest() {
                if (!this.secondsNeededToProcessRequest) {
                    return 'n/a'
                }

                return moment.utc(this.secondsNeededToProcessRequest * 1000).format('HH:mm:ss');
            },
        },

        methods: {
            async checkTimeNeededToGenerateDocuments() {
                const startTime = new Date().getTime()
                let requestTime = null

                try {
                    let response = await axios.get(Sincron.steps.preview)
                    requestTime = response.data.timeToProcess
                } catch (error) {
                    this.error = error.response.data.message
                    requestTime = 4 // roughly estimate in seconds
                }

                this.secondsNeededToProcessRequest = (requestTime * this.data.totalItems)

                if (this.secondsNeededToProcessRequest > 0 && this.secondsNeededToProcessRequest < 1) {
                    this.secondsNeededToProcessRequest = 1;
                }

                this.calculatingTimeToProcess = false
            },

            async generate() {
                this.showLoading()
                try {
                    await axios.post(Sincron.steps.generate)
                    if (this.showFinishButton === 'show') {
                      window.location.href = Sincron.steps.done
                    } else {
                      window.parent.postMessage('generate', '*');
                    }
                } catch (error) {
                    this.error = error.response.data.message
                }
                this.hideLoading()
            },

            showLoading() {
                this.generating = true;
                setInterval(() => {
                    ++this.secondsPassedSinceProcessingRequest
                }, 1000)
                eventBus.$emit('show-spinner');
            },

            hideLoading() {
                this.generating = false;
                eventBus.$emit('hide-spinner');
            }
        },

        mounted() {
            this.checkTimeNeededToGenerateDocuments()
        }
    }
</script>
